import Paper from "@mui/material/Paper";
import { Grid, IconButton, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
    FaCircleUserIcon,
    HeaderArrowDropDownIcon,
    HeaderContainer,
    LogoImg,
    LogoLink,
    UserDetails,
    UserDetailsText,
    UserDetailsTextStyle,
    UserMenuItemStyle,
    UserMenuPaperStyle
} from "../../styles/styles";
import { flexAlignCentre } from "../../../styles/mui/styles/display";
import { HeaderToolbar } from "../../styles/styles";
import { tangoLogo } from "../../../constants/ImagePaths";
import {
    AppRoutes,
    HeaderMenuLabels
} from "../../../constants/ApplicationUrl";
import { getValue } from "../../../utils";
import { LogoutResponse } from "../../../models/Api/Logout";
import { HeaderPaperStyle } from "../style";
import { Module } from "../../../models/Modules";
export interface PropsFromState {
  logoutResp: LogoutResponse;
  firstName: string;
  lastName: string;
  roleType: string;
  healthPlanName: string;
  userModules: Module[];
}
export interface PropsFromDispatch {
    logoutOfApp: () => void;
}

type AllProps = PropsFromDispatch & PropsFromState;

const Header: React.FC<AllProps> = ({ logoutOfApp, logoutResp,
    firstName,
    lastName,
    roleType,
    healthPlanName,
    userModules  }: AllProps) => {

    const { response: logOutResponse } = logoutResp;

    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isMenuOpen = Boolean(anchorEl);
    const isLoggedOut = pathname === AppRoutes.LOGOUT;
     const hasUserManagementAccess = userModules?.some((module) =>
      module.subModules?.some(
        (subModule) => subModule.routeUrl === "user-management",
      ),
    );

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        handleMenuClose();
        logoutOfApp();

    };
    
    useEffect(() => {
        if (getValue(logOutResponse, "message", "") === "Logged out.") {
          sessionStorage.clear();
          navigate(AppRoutes.LOGOUT, { replace: true });
        }
    }, [logOutResponse])

    const handleUserManagementClick = () => {
        setAnchorEl(null);
       navigate("/user-management")
    }

    return (
      <Grid container spacing={2} sx={{height: "4.5rem"}}>
        <Grid size={{ xs: 12 }}>
          <Paper elevation={3} sx={HeaderPaperStyle}>
            <HeaderToolbar disableGutters>
              <Grid container sx={HeaderContainer} size={"grow"}>
                <Grid size={"grow"}>
                  <Grid sx={flexAlignCentre} size={12}>
                    <LogoLink to="/">
                      <LogoImg
                        sizes="small"
                        alt="Tango Logo"
                        src={tangoLogo}
                      />
                    </LogoLink>
                  </Grid>
                </Grid>
                <Grid
                  container
                  size={"auto"}
                  wrap="nowrap"
                  sx={{
                    width: "fit-content",
                    maxWidth: { xs: "72%", sm: "58%", md: "52%" },
                    minWidth: 0,
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginLeft: "auto",
                  }}
                >
                  <Grid size={"grow"} sx={{ minWidth: 0 }}>
                    {!isLoggedOut && (
                      <Grid
                        container
                        size={"auto"}
                        wrap="nowrap"
                        sx={{ ...flexAlignCentre, gap: 1, minWidth: 0 }}
                      >
                        <Grid size={"auto"} sx={flexAlignCentre}>
                          <FaCircleUserIcon />
                        </Grid>

                        <UserDetails
                          id="demo-customized-button"
                          aria-haspopup="true"
                        >
                          <UserDetailsText sx={UserDetailsTextStyle(1)}>
                            {`${firstName} ${lastName}`.trim()}
                          </UserDetailsText>
                          <UserDetailsText sx={UserDetailsTextStyle(0)}>
                            {healthPlanName}
                          </UserDetailsText>
                          <UserDetailsText sx={UserDetailsTextStyle(0)}>
                            {roleType}
                          </UserDetailsText>
                        </UserDetails>
                      </Grid>
                    )}
                  </Grid>
                  <Grid size={"auto"}>
                    {!isLoggedOut && (
                      <>
                        <IconButton
                          id="user-menu-button"
                          aria-label="user menu"
                          aria-haspopup="true"
                          aria-controls={isMenuOpen ? "user-menu" : undefined}
                          aria-expanded={isMenuOpen ? "true" : undefined}
                          onClick={handleMenuOpen}
                          size="small"
                        >
                          <HeaderArrowDropDownIcon />
                        </IconButton>
                        <Menu
                          id="user-menu"
                          anchorEl={anchorEl}
                          open={isMenuOpen}
                          onClose={handleMenuClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          slotProps={{
                            paper: { sx: UserMenuPaperStyle },
                            list: { "aria-labelledby": "user-menu-button" },
                          }}
                        >
                         {hasUserManagementAccess && (
                            <MenuItem
                              onClick={handleUserManagementClick}
                              sx={UserMenuItemStyle}
                            >
                              {HeaderMenuLabels.USER_MANAGEMENT}
                            </MenuItem>
                          )}
                          <MenuItem
                            onClick={handleLogout}
                            sx={UserMenuItemStyle}
                          >
                            {HeaderMenuLabels.LOGOUT}
                          </MenuItem>
                        </Menu>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </HeaderToolbar>
          </Paper>
        </Grid>
      </Grid>
    );
};

export default Header;
